<template>
  <svg id="Layer_1" data-name="Layer 1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 642 642.88">
    <title>chart</title>
    <g id="Pracovní_plocha">
      <g id="_666297376" data-name=" 666297376">
        <path class="cls-1"
              d="M624.36,585.22l-551,.16c-4-22.6-1.7-103.21-1.7-135.58,0-17-2.38-30.82,3.41-44.63L227.23,282.1c3.31,11,102.64,192.26,118.41,201.26,19,10.75,36.15,2.79,43.7-10.45,13.6-23.94,27.35-63.19,39.14-89,26.89-59.06,53-117.95,78.81-177.31,11.37-26.12,34.85-29.12,76.78-50.58,32.43-16.59,70-20.32,63.45-66.18C626.84,47.08,544,105.72,491.88,131.16c-28.29,13.76-25.29,9-38.84,38.63-15.92,34.7-31.13,71.36-47.05,106.83-13.4,29.68-33.1,81.81-48.51,105.23-27.56-28.91-83.82-168.52-112.83-179.07-25.28-9.2-36.66,9.36-50.05,20L73.14,321.51c1.13-70.85.2-142.36.2-213.31,0-28.9,8.64-80.66-14.53-94.68C16.31-12.28,9.17,33.85,9.38,65.34c1,176.27-3.42,370.18-.16,542.48C10.15,655.08,37,648.67,80,648.46l542.43-.72C655.85,641.59,661.69,600.58,624.36,585.22Z"
              transform="translate(-8 -5.98)" />
        <path class="cls-1"
              d="M624.36,585.22c-21.41-8.43-487.57-5.17-549.93-2.94l.67-177.11c-5.79,13.81-3.46,27.61-3.41,44.63,0,32.37-2.28,113,1.7,135.58Z"
              transform="translate(-8 -5.98)" />
      </g>
    </g>
  </svg>
</template>

<script>
export default {
  name: 'Chart',
};
</script>

<style scoped>
.cls-1 {
  fill: #666;
  fill-rule: evenodd;
}
</style>
